export default __webpack_public_path__ + "static/media/logo-breaker.2ede0d08.png";